import React from 'react';
import Seo, { SITE } from '../components/Seo/Seo';
import ProjectRequestSection from '../components/ProjectRequestSection/ProjectRequestSection';
import SkillsetSection from '../components/SkillSetSection/SkillsetSection';
import AppDevHeroSection from '../components/AppDev/AppDevHeroSection';
import FAQSection from '../components/FAQSection/FAQSection';
import { appDevFAQs, appDevIntro } from '../data/AppDev/AppDevFAQ';
import AppLogoSlider from '../data/AppDev/AppLogoSlider';
import appSkillsets from '../data/AppDev/AppDevSkillsetData';
import AppExpertise from '../data/AppDev/AppExpertise';
import ProjectSteps from '../components/ProjectSteps/ProjectSteps';
import appDevSteps from '../data/AppDev/AppProjectSteps';

const serviceJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'Service',
  name: 'App-Entwicklung',
  serviceType: 'Mobile App Entwicklung (iOS & Android)',
  description:
    'Native und plattformübergreifende App-Entwicklung mit Flutter, React Native, Swift und Kotlin – von der Konzeption bis zum App-Store-Release.',
  provider: { '@id': `${SITE.url}/#organization` },
  areaServed: ['Köln', 'Bonn', 'Deutschland'],
  url: `${SITE.url}/services/app-development`,
};

const AppDev = () => {
  return (
    <>
      <Seo
        title="App-Entwicklung Köln: iOS & Android Apps | Nexite IT"
        description="Wir entwickeln maßgeschneiderte Mobile Apps für iOS und Android – nativ oder mit Flutter und React Native. Ihre App-Agentur aus Köln für Konzeption, Entwicklung und Betrieb."
        path="/services/app-development"
        jsonLd={serviceJsonLd}
      />

      <AppDevHeroSection />
      <ProjectSteps title="Unser App-Entwicklungsprozess" steps={appDevSteps} />
      <SkillsetSection
        skillsets={appSkillsets}
        title="Technische Kompetenzen"
        subtitle="Wodurch sich unsere App-Entwicklung auszeichnet"
      />
      <AppLogoSlider />
      <AppExpertise />
      <ProjectRequestSection />
      <FAQSection faqs={appDevFAQs} intro={appDevIntro} />
    </>
  );
};

export default AppDev;
